import { getTimeMillisApi } from '@/api/common'
import { getDayjsLocalTime } from '@/utils/day'
import dayjs from 'dayjs'

const state = {
  innerWH: {}, // 浏览器窗口宽高
  // 系统时间
  systemTime: ''
}

const mutations = {
  SET_INNER_WH(state, val) {
    state.innerWH = val
  },
  SET_SYSTEM_TIME(state, time) {
    state.systemTime = time
  }
}

const actions = {
  setInnerWH({ commit }, val) {
    commit('SET_INNER_WH', val)
  },

  /**
   * 获取系统时间（不精确）
   * @param commit
   * @param axios
   * @returns {Promise<unknown>}
   */
  getSystemTime({ commit }, axios) {
    return new Promise((resolve, reject) => {
      getTimeMillisApi(axios)
        .then((res) => {
          commit('SET_SYSTEM_TIME', res.data || '')
          resolve(res.data)
        })
        .catch(() => {
          commit('SET_SYSTEM_TIME', Date.now())
          resolve(Date.now())
        })
    })
  }
}

const getters = {
  // 双十一活动时间控制变量
  isActivityTime: () => {
    // 活动开始时间
    const startTime = dayjs.tz('2026-03-02 00:00:00', 'Asia/Shanghai')
    // 活动结束时间
    const endTime = dayjs.tz('2026-04-03 23:59:59', 'Asia/Shanghai')
    // 获取当前本地时间（上海时区）
    const nowTime = getDayjsLocalTime()

    // 判断当前时间是否在活动区间内（包含开始时间，不包含结束时间）
    return nowTime.isAfter(startTime) && nowTime.isBefore(endTime)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
